import * as S from "./style"

export default function ContentHeadline({emoji, text}) {
    return (
        <S.Container>
            <div className="emoji">{emoji}</div>
            <div className="text"><p>{text}</p></div>
        </S.Container>
    )
}